import React, { useEffect, useState } from "react";
import { fetchObra, selector } from "../../../redux/slices/ObrasSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { logout, useAuthDispatch } from "../../../context";
import { StyledForm } from "../../../style";

const MAX_ENTRADAS_POR_COMPRA = 10;

function SeleccionarFechas({ setDetallesCompra, detallesCompra, titulo }) {
    const dispatch = useDispatch();
    const dispatchAuth = useAuthDispatch();
    const navigate = useNavigate();
    const { id, date } = useParams();
    const [localNotas, setLocalNotas] = useState(detallesCompra?.notasEspeciales || "");

    const { obra } = useSelector(selector);

    const { fechasClean } = obra;

    // D1: revalidar stock cada vez que cambia id o la fecha seleccionada.
    useEffect(() => {
        if (!obra.titulo || obra._id !== id) dispatch(fetchObra(id));
    }, [id, dispatch, obra._id, obra.titulo])

    const disponibles = entradasDisponibles();

    // D2: si la cantidad supera el stock disponible tras un cambio, la ajustamos.
    useEffect(() => {
        if (!isNaN(disponibles) && disponibles > 0 && Number(detallesCompra?.cantidad) > disponibles) {
            setDetallesCompra({
                ...detallesCompra,
                cantidad: Math.min(disponibles, MAX_ENTRADAS_POR_COMPRA)
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disponibles])

    const cantidades = []
    const tope = Math.min(disponibles, MAX_ENTRADAS_POR_COMPRA);
    for (let i = 1; i <= tope; i++) {
        cantidades.push(i);
    }

    const handleChangeCantidad = async values => {
        setDetallesCompra({
            ...detallesCompra,
            cantidad: values.target.value
        })
    }

    const handleChangeFechas = async values => {
        const arr = window.location.pathname.split('/');
        arr[arr.length - 3] = values.target.value;
        const route = arr.join("/");
        // D2: al cambiar fecha, resetear cantidad a 1 (lo ajustamos arriba si hace falta).
        setDetallesCompra({
            ...detallesCompra,
            fechaObra: values.target.value,
            cantidad: 1
        })
        // D1: refetch obra para asegurar stock fresco.
        dispatch(fetchObra(id));
        navigate(route);
    }

    function entradasDisponibles() {
        // D4: comparar como números, evitar coerción frágil.
        const target = Number(detallesCompra?.fechaObra);
        const fechaAux = obra?.fechasClean?.find(f => Number(f.fecha) === target);
        return parseInt(fechaAux?.disponibles)
    }

    const handleSubmit = async (e) => {
        if (e?.preventDefault) e.preventDefault();
        // D5: sin setTimeout. Persistimos directamente a localStorage para
        // garantizar que /pago (que lee de localStorage) tenga las notas
        // aunque navigate ocurra antes del próximo render.
        const actualizado = { ...detallesCompra, notasEspeciales: localNotas || "" };
        setDetallesCompra(actualizado);
        try {
            localStorage.setItem("detallesCompra", JSON.stringify(actualizado));
        } catch (_) { /* storage lleno o bloqueado: ignoramos */ }
        const route = window.location.pathname.split('/').slice(0, -1).join('/') + '/pago';
        navigate(route)
    }

    async function logOut() {
        await logout(dispatchAuth);
    }
    return (
        <StyledForm>
            <form onSubmit={handleSubmit}>
                <h1>{titulo}</h1>
                <div>
                    <h3>Comprar entradas para:</h3>
                    <h1>{detallesCompra?.titulo}</h1>
                    <p>Cantidad:</p>
                    <label>{detallesCompra?.cantidad}</label>
                    <p>Enviar a:</p>
                    <label>{detallesCompra?.email}</label>
                    <p>Teléfono de contacto:</p>
                    <label>{detallesCompra?.phone}</label>
                    <p>Notas e indicaciones especiales</p>
                    <textarea
                        key="text-area-notas"
                        value={localNotas}
                        onChange={(e)=>setLocalNotas(e.target.value)}
                        rows="5"
                        cols="50"
                        placeholder="Escribe aquí..."
                    />
                    <label>
                        Fecha:&nbsp;&nbsp;
                        <select onChange={handleChangeFechas} value={detallesCompra.fechaObra} id="fechas-select">
                            {fechasClean?.map((item, index) => {
                                return (<option key={index} value={item.fecha}>{
                                    new Date(item.fecha).toLocaleDateString("es-ES", {
                                        weekday: 'long',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric'
                                    })}</option>);
                            })}
                        </select>
                    </label>
                </div>
                <div>
                    {disponibles > 0 ?
                        <>
                            <label>
                                Cantidad:&nbsp;&nbsp;
                                <select onChange={handleChangeCantidad} value={detallesCompra.cantidad}>
                                    {cantidades?.map(item => {
                                        return (<option key={item} value={item}>{item}</option>);
                                    })}
                                </select>
                            </label>
                            {disponibles > MAX_ENTRADAS_POR_COMPRA && (
                                <p style={{ fontSize: "0.9em" }}>Máximo {MAX_ENTRADAS_POR_COMPRA} entradas por compra.</p>
                            )}
                        </> :
                        <pre>Agotadas</pre>}
                </div>
                <div>
                    {disponibles > 0 && <button type='submit'>Pagar</button>}
                    <button type="button" onClick={(e) => { e.preventDefault(); navigate("/sala/programacion") }}>Volver</button>
                </div>
                <a id="cerrar" onClick={logOut}>Cerrar sesión</a>

            </form>
        </StyledForm>
    );
}

export default SeleccionarFechas;